import { Button, Menu } from 'antd';
import { ArrowRight } from 'assets/images';
import PropType from 'prop-types';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectGlobalUserInfo } from 'state/global/auth/selector';
import { signOut } from 'util/auth';

const LogoutMenu = ({ setShowProfile }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const globalUserInfo = useSelector((state) => selectGlobalUserInfo(state));

  const handleLogout = useCallback(async () => {
    await signOut();
    history.push('/');
  }, [history]);

  return (
    <Menu>
      <div className="user-menu-body">
        <div className="user-id">
          <span className="my-id">{t('userInfo.myId')}</span>
          <p className="my-username">{globalUserInfo?.preferred_username}</p>
        </div>

        <Menu.Item
          key="2"
          className="my-profile"
          icon={<ArrowRight />}
          onClick={() => setShowProfile(true)}>
          {t('userInfo.myProfile')}
        </Menu.Item>

        <div className="logout-button">
          <Button onClick={handleLogout} className="base-yellow-btn">
            {t('userInfo.logoutButton')}
          </Button>
        </div>
      </div>
    </Menu>
  );
};

LogoutMenu.propTypes = {
  setShowProfile: PropType.func.isRequired
};

export default LogoutMenu;
